<template>
  <a-modal
      :title="title"
      :visible="visible"
      :width="1000"
      @ok="handleSubmit"
      @cancel="handleCancel">
    <a-form :form="form">
      <a-form-item label="菜单名称" :labelCol="labelCol" :wrapperCol="wrapperCol">
        <a-input v-decorator.trim="[ 'name', validatorRules.name]"/>
      </a-form-item>
      <a-form-item label="上级菜单" :labelCol="labelCol" :wrapperCol="wrapperCol">
        <a-tree-select
            :dropdown-style="{ maxHeight: '400px', overflow: 'auto' }"
            :tree-data="treeData"
            v-decorator.trim="[ 'parentId', validatorRules.parentId]"
        >
        </a-tree-select>
      </a-form-item>
      <a-form-item label="菜单路径" :labelCol="labelCol" :wrapperCol="wrapperCol">
        <a-input v-decorator.trim="[ 'url', validatorRules.url]"/>
      </a-form-item>
      <a-form-item label="前端组件" :labelCol="labelCol" :wrapperCol="wrapperCol">
        <a-input v-decorator.trim="[ 'component', validatorRules.component]"/>
      </a-form-item>
      <a-form-item label="菜单图标" :labelCol="labelCol" :wrapperCol="wrapperCol">
        <a-input v-decorator.trim="['icon']"/>
      </a-form-item>
      <a-form-item label="权限标记" :labelCol="labelCol" :wrapperCol="wrapperCol">
        <a-input v-decorator.trim="[ 'authority', validatorRules.authority]"/>
      </a-form-item>
      <a-form-item label="排序" :labelCol="labelCol" :wrapperCol="wrapperCol">
        <a-input-number :min="1" v-decorator.trim="[ 'sort', validatorRules.sort]" style="width: 100%"/>
      </a-form-item>
    </a-form>
  </a-modal>

</template>

<script>
import pick from "lodash/pick";
import {HttpMixins} from "@/mixins/http-mixins";

export default {
  name: "PermissionCreateModal",
  mixins: [HttpMixins],
  data() {
    return {
      treeData: [],
      title: '',
      visible: false,
      model: {},
      form: this.$form.createForm(this),
      labelCol: {
        xs: {span: 24},
        sm: {span: 5},
      },
      wrapperCol: {
        xs: {span: 24},
        sm: {span: 18},
      },
      validatorRules: {
        name: {rules: [{required: true, message: '请输入名称!'}]},
        url: {},
        component: {},
        authority: {rules: [{required: true, message: '请输入标记名称!'}]},
        sort: {rules: [{required: true, message: '请输入排序!'}]}
      },
      url: {
        add: window._CONFIG['domainURL'] + "/permission",
        edit: window._CONFIG['domainURL'] + "/permission",
        parent: window._CONFIG['domainURL'] + "/permission/parent",
        tree: window._CONFIG['domainURL'] + "/permission/tree",
      }
    }
  },

  methods: {
    add() {
      this.visible = true;
      this.title = '新增';
      this.model = {};
      this.form.resetFields();
      this.loadTree();
    },

    edit(record) {
      let that = this;
      this.add();
      that.title = '编辑';
      that.model = Object.assign({}, record);
      that.$nextTick(() => {
        that.form.setFieldsValue(pick(that.model, 'name', 'parentId', 'url', 'component', 'menuType', 'sort', 'authority', 'icon'));
      });
    },

    loadTree() {
      let that = this;
      const handleSuccess = (res) => {
        if (res) {
          that.treeData = res.data;
        }
      }
      that.$axios.get(that.url.tree, {headers: that.headers})
          .then(handleSuccess)
          .catch((error) => that.catchError(error).then(handleSuccess));
    },

    handleSubmit() {

      const that = this;
      this.form.validateFields((err, values) => {
        if (!err) {
          if (that.title === '编辑') {
            values.id = that.model.id;
            const handleSuccess = (res) => {
              if (res) {
                let response = res.data;
                if (response.code === 200) {
                  that.$message.success(response.msg);
                  that.$emit('ok');
                  that.handleCancel();
                } else {
                  that.$message.error(response.msg);
                }
              }
            }
            that.$axios.put(that.url.edit, values, {headers: that.headers})
                .then(handleSuccess)
                .catch((error) => that.catchError(error).then(handleSuccess));
          }
          if (that.title === '新增') {
            const handleSuccess = (res) => {
              if (res) {
                let response = res.data;
                if (response.code === 200) {
                  that.$message.success(response.msg);
                  that.$emit('ok');
                  that.handleCancel();
                } else {
                  that.$message.error(response.msg);
                }
              }
            }
            that.$axios.post(that.url.add, values, {headers: that.headers})
                .then(handleSuccess)
                .catch((error) => that.catchError(error).then(handleSuccess));
          }
        }
      })
    },
    handleCancel() {
      this.visible = false;
    }
  }

}
</script>

<style scoped>

</style>
